import React, { useRef } from 'react';
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Page,
  Toolbar,
  ExcelExport,
  PdfExport,
  ColumnChooser,
} from '@syncfusion/ej2-react-grids';
import has from 'lodash/has';
import toString from 'lodash/toString';
import { getFromLocalStorage } from 'localStorageService/LocalStorage';
import { PdfTrueTypeFont } from '@syncfusion/ej2-pdf-export';
import { calibriFont } from 'constant/PdfFont';
// constants
import { localStorageKeys } from 'constant/Enums';

const ProductTypeBreakDownDataGrid = ({ data, category }) => {
  const toolbarOptions = ['ExcelExport', 'PdfExport', 'CsvExport', 'ColumnChooser', 'Search'];
  const ref = useRef();
  const opsCenter = getFromLocalStorage(localStorageKeys.OPS_CENTER);

  const toolbarClick = (args) => {
    const pdfExportProperties = {
      theme: {
        caption: { font: new PdfTrueTypeFont(calibriFont, 10) },
        header: { font: new PdfTrueTypeFont(calibriFont, 12) },
        record: { font: new PdfTrueTypeFont(calibriFont, 9) },
      },
    };
    switch (args.item.text) {
      case 'PDF Export':
        ref.current.pdfExport(pdfExportProperties);
        break;
      case 'Excel Export':
        ref.current.excelExport();
        break;
      case 'CSV Export':
        ref.current.csvExport();
        break;
      default:
        break;
    }
  };

  const excelQueryCellInfo = (args) => {
    if (has(args.column, 'customExcelTemplate')) {
      args.value = toString(args.column.customExcelTemplate(args.data));
    }
  };

  return (
    <div className="control-pane">
      <div className="control-section">
        <GridComponent
          dataSource={data}
          allowPaging={true}
          toolbar={toolbarOptions}
          allowExcelExport={true}
          allowPdfExport={true}
          excelQueryCellInfo={excelQueryCellInfo}
          pdfQueryCellInfo={excelQueryCellInfo}
          ref={ref}
          toolbarClick={toolbarClick}
          rowHeight={60}
          showColumnChooser={true}
          allowTextWrap={true}
          pageSettings={{ pageSizes: true, pageSize: 20 }}
        >
          <ColumnsDirective>
            <ColumnDirective
              headerText={category ? 'Country' : 'Type'}
              field="name"
              width={150}
              customExcelTemplate={(rowData) => rowData.name}
              textAlign="Center"
            />
            <ColumnDirective
              headerText={category ? 'Live' : 'Products'}
              field="prodcount"
              width={100}
              customExcelTemplate={(rowData) => rowData.prodcount}
              textAlign="Center"
            />
            <ColumnDirective
              headerText="Floward Flowers"
              field="flowers"
              width={120}
              customExcelTemplate={(rowData) => rowData.flowers}
              textAlign="Center"
            />
            <ColumnDirective
              headerText="Floward Flowers%"
              template={(rowData) => (
                <span>{`${
                  rowData.percentflowers != null &&
                  rowData.percentflowers.toFixed(opsCenter?.country?.decimalNumber ?? 2)
                }%`}</span>
              )}
              width={150}
              customExcelTemplate={(rowData) =>
                `${
                  rowData.percentflowers != null &&
                  rowData.percentflowers.toFixed(opsCenter?.country?.decimalNumber ?? 2)
                }%`
              }
              textAlign="Center"
            />
            <ColumnDirective
              headerText="Brands"
              field="brand"
              width={80}
              customExcelTemplate={(rowData) => rowData.brand}
              textAlign="Center"
            />
            <ColumnDirective
              headerText="Brands%"
              template={(rowData) => (
                <span>{`${
                  rowData.percentbarnd != null &&
                  rowData.percentbarnd.toFixed(opsCenter?.country?.decimalNumber ?? 2)
                }%`}</span>
              )}
              width={120}
              customExcelTemplate={(rowData) =>
                `${
                  rowData.percentbarnd != null &&
                  rowData.percentbarnd.toFixed(opsCenter?.country?.decimalNumber ?? 2)
                }%`
              }
              textAlign="Center"
            />
            <ColumnDirective
              headerText="Designers"
              field="designer"
              width={80}
              customExcelTemplate={(rowData) => rowData.designer}
              textAlign="Center"
            />
            <ColumnDirective
              headerText="Desingers%"
              template={(rowData) => (
                <span>{`${
                  rowData.percentdesigner != null &&
                  rowData.percentdesigner.toFixed(opsCenter?.country?.decimalNumber ?? 2)
                }%`}</span>
              )}
              width={150}
              customExcelTemplate={(rowData) =>
                `${
                  rowData.percentdesigner != null &&
                  rowData.percentdesigner.toFixed(opsCenter?.country?.decimalNumber ?? 2)
                }%`
              }
              textAlign="Center"
            />
          </ColumnsDirective>
          <Inject services={[Toolbar, ExcelExport, PdfExport, ColumnChooser, Page]} />
        </GridComponent>
      </div>
    </div>
  );
};

export default React.memo(ProductTypeBreakDownDataGrid);
